angular.module('mercury.modules.reports.items', []);
